import { lazy, Suspense } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

// Lazy load heavy chart components
const LazyAdminCharts = lazy(() => 
  import('@/components/admin/AdminCharts').then(module => ({
    default: module.AdminCharts
  }))
);

// Chart loading skeleton
const ChartSkeleton = ({ className = '' }: { className?: string }) => (
  <div className={`space-y-4 ${className}`}>
    <Skeleton className="h-8 w-48" />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Skeleton className="h-[300px] w-full rounded-xl" />
      <Skeleton className="h-[300px] w-full rounded-xl" />
    </div>
  </div>
);

// Re-export lazy component
export { LazyAdminCharts };

// Export skeleton for custom usage
export { ChartSkeleton };
